module.exports = __webpack_public_path__ + "static/media/background3.2dd56657.png";